declare const __ACQ_VERSION__: string;
declare const __ACQ_RELEASED_AT__: string;

export const ACQ_CLIENT_VERSION = __ACQ_VERSION__;
export const ACQ_CLIENT_RELEASED_AT = __ACQ_RELEASED_AT__;
